import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { ToastPosition } from './types';

export interface ToasterConfig {
  position: ToastPosition;
  /** Always show toasts expanded instead of stacked. */
  expand: boolean;
  /** Maximum number of toasts visible at the same time. */
  visibleToasts: number;
  /** Default time in ms before a toast closes itself. */
  duration: number;
  richColors: boolean;
  closeButton: boolean;
  /** Gap in px between expanded toasts. */
  gap: number;
  /** Distance in px from the edges of the viewport. */
  offset: number;
  /** Distance in px from the edges of the viewport on screens narrower than 600px. */
  mobileOffset: number;
  /** Keys that focus the toasts, as `KeyboardEvent` boolean properties or `code` values. */
  hotkey: string[];
  pauseWhenPageIsHidden: boolean;
  containerAriaLabel: string;
  closeButtonAriaLabel: string;
}

export const DEFAULT_TOASTER_CONFIG: ToasterConfig = {
  position: 'bottom-right',
  expand: false,
  visibleToasts: 3,
  duration: 4000,
  richColors: false,
  closeButton: false,
  gap: 14,
  offset: 24,
  mobileOffset: 16,
  hotkey: ['altKey', 'KeyT'],
  pauseWhenPageIsHidden: true,
  containerAriaLabel: 'Notifications',
  closeButtonAriaLabel: 'Fermer la notification',
};

export const TOASTER_CONFIG = new InjectionToken<Partial<ToasterConfig>>('TOASTER_CONFIG', {
  factory: () => ({}),
});

export function provideToaster(config: Partial<ToasterConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: TOASTER_CONFIG, useValue: config }]);
}
